import React from 'react';
import PropTypes from 'prop-types';

import styles from './DateBreak.scss';

export default function DateBreak({ time }) {
    return (
        <div className={styles.root}>
            <div className={styles.content}>{time.format('dddd, MMMM Do YYYY')}</div>
        </div>
    );
}

DateBreak.propTypes = {
    time: PropTypes.object.isRequired,
};
